const FETCH_ORDERS = 'fetch_orders';
const FETCH_ORDERS_FULLY = 'fetch_orders_fully';
const FETCH_ORDER = 'fetch_order';
const DELETE_ORDER = 'delete_order';
const PERSIST_ORDER = 'persist_order';
const CREATE_FILES_ORDER = 'create_files_order';
const CREATE_FILES_IN_ORDER = 'create_files_in_order';
const DELETE_FILE_ORDER = 'delete_file_order';
const FETCH_FILES_ORDER = 'fetch_files_order';
const FETCH_CHECK_ORDERS = 'fetch_check_orders';
export default {
    FETCH_ORDERS,
    FETCH_ORDERS_FULLY,
    FETCH_ORDER,
    DELETE_ORDER,
    PERSIST_ORDER,
    FETCH_FILES_ORDER,
    DELETE_FILE_ORDER,
    CREATE_FILES_ORDER,
    CREATE_FILES_IN_ORDER,
    FETCH_CHECK_ORDERS,
};
